import type { Comic } from "@/types/comic";

export function formatCount(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function sortByUpdated(list: Comic[]): Comic[] {
  return [...list].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
}

export function sortByHot(list: Comic[]): Comic[] {
  return [...list].sort((a, b) => b.views - a.views);
}

export function sortByRating(list: Comic[]): Comic[] {
  return [...list].sort((a, b) => b.rating - a.rating);
}

export interface FilterState {
  genre: string;
  status: string;
  tag: string;
  sort: string;
  keyword: string;
}

export function filterComics(list: Comic[], state: FilterState): Comic[] {
  const kw = state.keyword.trim().toLowerCase();
  const result = list.filter((comic) => {
    if (state.genre !== "全部" && !comic.genres.includes(state.genre)) return false;
    if (state.status !== "全部" && comic.status !== state.status) return false;
    if (state.tag !== "全部" && !comic.tags.includes(state.tag)) return false;
    if (kw) {
      const haystack = [comic.title, comic.author, ...comic.genres, ...comic.tags]
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(kw)) return false;
    }
    return true;
  });

  if (state.sort === "hot") return sortByHot(result);
  if (state.sort === "rating") return sortByRating(result);
  return sortByUpdated(result);
}

export function relatedComics(list: Comic[], comic: Comic, limit = 4): Comic[] {
  const scored = list
    .filter((item) => item.id !== comic.id)
    .map((item) => {
      const overlap = item.genres.filter((g) => comic.genres.includes(g)).length;
      return { item, overlap };
    })
    .sort((a, b) => b.overlap - a.overlap || b.item.views - a.item.views);
  return scored.slice(0, limit).map((entry) => entry.item);
}